import { readonly, ref } from 'vue';
import { defineStore } from 'pinia';
import { map } from 'rxjs';

import { isFeatureToggleActive } from '@libs/feature-toggle';

import type { SemboUser } from '../models/semboUser';
import { UserService } from '../services/userService/userService';

const userService = new UserService();

export const useUserStore = defineStore('UserStore', () => {
  window.addEventListener('semboUserLoggedIn', (event: Event) => {
    const customEvent = event as CustomEvent<{ user: SemboUser }>;
    if (customEvent.detail?.user) {
      isUserLoggedIn.value = true;
    }
  });

  // State
  const isUserLoggedIn = ref(false);

  // Actions
  function fetchLoginStatus(): void {
    // GetMember is cookie-bound and fails cross-origin; GetMemberAuth replaces it on webapi hosts.
    const isLoggedIn$ = isFeatureToggleActive('webapi-domain')
      ? userService.fetchMemberAuth().pipe(map((data) => data.isAuthenticated))
      : userService.fetchSemboUser().pipe(map(() => true));

    isLoggedIn$.subscribe((isLoggedIn) => {
      isUserLoggedIn.value ||= isLoggedIn;
    });
  }

  return {
    // State
    isUserLoggedIn: readonly(isUserLoggedIn),

    // Actions
    fetchLoginStatus,
  };
});
